import { Loader } from "rsuite";

export default function FallbackLoader() {
  return (
    <div className="fallback-loader">
      <Loader backdrop size="md" />
    </div>
  );
}
